//所有有关用户信息的网络请求
import http from '../utils/http'

//freeGift,第一步 根据订单号查询客户订单信息
export function freeGiftOrder(data){
    return http({
      url:'/free/order',
      method:'post',
      data
    })
  }
//share-experience,第一步 客户提交信息
export function freeGiftOrderTow(data){
  return http({
    url:'/free/order/two',
    method:'post',
    data
  })
}
// share-experience-2 第三步 客服提交喜欢度和评论
export function freeGiftOrderThree(data){
  return http({
    url:'/free/order/three',
    method:'post',
    data
  })
}
// share-experience-4 第四步 客户提交个人信息
export function freeGiftOrderFour(data){
  return http({
    url:'/free/order/four',
    method:'post',
    data
  })
}